export function FilterCampaigns(data, filterBy) {
  const { media_buyer, scaling_status, action_status, text } = filterBy;

  let campaigns = [...data];

  // Filter Campaign By Media Buyer and Scaling Status
  if (media_buyer || scaling_status) {
    campaigns = campaigns.filter((campaign) => {
      if (media_buyer) {
        if (
          media_buyer === campaign.media_buyer &&
          scaling_status.includes(campaign.scaling_status)
        ) {
          return campaign;
        }
      } else {
        if (scaling_status.includes(campaign.scaling_status)) {
          return campaign;
        }
      }
    });
  }

  // Filter Campaign By Action Status
  if (action_status.length > 0) {
    campaigns = campaigns.filter((campaign) => {
      const matched = campaign.actions.filter((action) => {
        if (action_status.includes(action.status)) {
          return action;
        }
      });

      if (matched.length > 0) return campaign;
    });
  }

  // Filter Campaign By Search Text
  campaigns = campaigns.filter((campaign) => {
    const regex_text = new RegExp(`${text}`, "gi");

    if (campaign.laptop.match(regex_text)) {
      return campaign.laptop.match(regex_text);
    }
    if (campaign.angle.match(regex_text)) {
      return campaign.angle.match(regex_text);
    }
  });

  return campaigns;
}
